import BalanzaIngresos from './reports/BalanzaIngresos';
import IngresosMensual from './reports/IngresosMensual';
import DiferenciaBalanzas from './reports/DiferenciaBalanzas';
import InformeFinancieroMensual from './reports/InformeFinancieroMensual';
import PagosSemanales from './reports/PagosSemanales';
import ConcentradoPorProveedor from './reports/ConcentradoPorProveedor';
import Inventarios from './reports/Inventarios';
import Presupuestos from './reports/Presupuestos';

// Familias en las que se agrupa el índice de reportes (ReportsScreen los lista en este orden).
export const REPORT_GROUPS = ['Balanza de ingresos', 'Informe financiero', 'Otros'] as const;
export type ReportGroup = (typeof REPORT_GROUPS)[number];

// Periodo que aplica cada reporte: 'month' | 'week' | null (sin selector).
export type ReportPeriod = 'month' | 'week' | null;

export type ReportEntry = {
  title: string;
  group: ReportGroup;
  period: ReportPeriod;
  component: React.ComponentType<{ communityId?: string; date?: Date }>;
};

// Catálogo único de reportes. Para agregar/quitar un reporte se toca SOLO este archivo:
// los navigators registran rutas genéricas (índice + detalle parametrizado por reportKey).
export const REPORTS = {
  balanza_ingresos:      { title: 'Balanza ingresos',                         group: 'Balanza de ingresos', period: 'month', component: BalanzaIngresos },
  ingresos_mensual:      { title: 'Reporte general ingresos mensual',         group: 'Balanza de ingresos', period: 'month', component: IngresosMensual },
  diferencia_balanzas:   { title: 'Diferencia balanzas',                      group: 'Balanza de ingresos', period: 'month', component: DiferenciaBalanzas },
  informe_mensual:       { title: 'Informe financiero mensual',              group: 'Informe financiero',  period: 'month', component: InformeFinancieroMensual },
  pagos_semanales:       { title: 'Pagos semanales',                         group: 'Informe financiero',  period: 'week',  component: PagosSemanales },
  concentrado_proveedor: { title: 'Concentrado por proveedor',               group: 'Informe financiero',  period: 'month', component: ConcentradoPorProveedor },
  inventarios:           { title: 'Reporte inventarios',                     group: 'Otros',               period: 'month', component: Inventarios },
  presupuestos:          { title: 'Presupuestos',                            group: 'Otros',               period: null,    component: Presupuestos },
} satisfies Record<string, ReportEntry>;

export type ReportKey = keyof typeof REPORTS;
